import React from 'react';
import { Card, CardHeader, CardBody, CardFooter, Stack, Image, Text, Heading, Button } from '@chakra-ui/react';
import moment from 'moment/moment';
import smallecho from '../Images/C-ECHO/1.1.jpg';
import smallNimar from '../Images/Nimar/shopzzz-1.jpg';

export default function CardBooking(props) {

    return (
        <section style={{ padding: '20px' }} className="d-flex flex-column align-items-center">
            <Card
                direction={{ base: 'column', sm: 'row' }}
                overflow='hidden'
                variant='outline'
            >
                <Image
                    objectFit='cover'
                    maxW={{ base: '100%', sm: '300px' }}
                    src={props.boat === "Nimar" ? smallNimar : smallecho}
                    alt='Caffe Latte'
                />

                <Stack>
                    <CardBody>
                        <Heading size='md'>{props.route}</Heading>
                        <Heading size='sm'>{props.boat}</Heading>
                        <Text py='2'>
                            {`Start Date: ${moment(props.date).format('DD MMM')}`}
                        </Text>
                        <Text>
                            {`End Date: ${moment(props.date).add('d', 7).format('DD MMM')}`}
                        </Text>
                    </CardBody>
                </Stack>
            </Card>
        </section>
    );
}